<template>
  <div class="flex justify-center items-center w-full h-[calc(100vh-95px)]">
    <h2 class="text-coral text-base">An error occurred: {{ errorMessage }}</h2>
  </div>
</template>
<script setup lang="ts">
  import { computed } from 'vue';
  interface Props {
    error: Error | string;
  }

  const props = defineProps<Props>();

  const errorMessage = computed(() => {
    if (typeof props.error === 'string') {
      return props.error;
    }
    return props.error.message || 'An unknown error occurred';
  });
</script>
